import React, { useState, useEffect } from "react";
import {
  CssBaseline,
  Box,
  TextField,
  Button,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material"; 
import Newsidebar from "../components/shared/newsidebar";
import "../components/home/home.style.css";
import Newheader from "../components/shared/newheader";
import MetaDecorator from "../services/meta_decorator";
import { getApiUrl } from "../services/api_service";
import InactivityMeter from "../components/shared/inactivitymeter";
import Footer from "../components/shared/footer";
import { bodyBg2, dashboardText, footerContainer, fullHeight, lightcolor, paddingbox, pcolor, rcolor, whitecolor } from "../style2";

export default function Contact() {
  

  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleMessageChange = (event) => {
    const text = event.target.value;
    setMessage(text);
  };

  const sentContactMessage = async () => {
    setError("");
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      return;
    }
    if (message === "") {
      setError("Message is required.");
      return;
    }
    setLoading(true);
    setSuccess('');
    try {
      const fd = new FormData();
      fd.append("message", message);
      const response = await fetch(`${getApiUrl()}/EmailTemplate/contact`, {
        method: "post",
        body: fd,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      if (!response.ok) {
        response.json().then(data => {
          //console.log(data);
        }).catch(err => {
          console.log(err);
        });
        throw new Error("Network response was not ok " + response.statusText);
      }

      if (response.headers.get('Content-Length') === '0') {
        console.log('No content in the response');
        setError('Received an empty response from the server.');
      } else {
        setSuccess('Thank you for contacting us, we will be be in touch with you soon.');
      }
    } catch (error) {
      setError(error.message || "An error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{...fullHeight, ...bodyBg2}}>
      <CssBaseline />
      <MetaDecorator title={"EnrichMyCare - Contact"} description={"Professional dashboard app"} />
      <Newsidebar />
      <Newheader show_profile_button={true} />
      {/* <Box mt={12} /> */}
      <Box sx={paddingbox} >
        <Typography variant="h5" sx={dashboardText}>
          Contact
        </Typography>
        <Box m={2} />
        <Box sx={{ background: lightcolor, border: `1px solid ${whitecolor}`, borderRadius: "5px", padding: "2rem", ...dashboardText }}>
          <Grid container spacing={2} xs={12} sm={12}>
            <Grid item xs={12} sm={12}>
              <label style={{ color: pcolor, fontSize: "16px" }}>Message</label>
              <div style={{ backgroundColor: whitecolor, display: "block", marginTop: "15px" }}>
                <TextField label="" variant="outlined" multiline rows={7} fullWidth value={message} onChange={handleMessageChange}
                  inputProps={{ maxLength: 300 }} InputProps={{
                    endAdornment: (
                      <Typography variant="outlined" style={{ position: 'absolute', bottom: '8px', right: '8px', color: 'lightgray' }} >
                        {300 - message.length} characters remaining
                      </Typography>
                    ),
                  }} />
              </div>
            </Grid>
            <Grid item xs={12}>
              <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: "15px" }}>
                {loading ? <CircularProgress /> : <Button variant="contained" style={{ backgroundColor: rcolor, color: whitecolor }} onClick={sentContactMessage}>
                  Submit
                </Button>}
              </Box>
              {error !== "" ?
                <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: "15px" }}>
                  <Typography style={{ color: "red" }}>{error}</Typography>
                </Box> : null}
              {success !== "" ?
                <Box display="flex" justifyContent="center" alignItems="center" style={{ marginTop: "15px" }}>
                  <Typography style={{ color: "green" }}>{success}</Typography>
                </Box> : null}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <InactivityMeter />
      <Box sx={footerContainer}>
        <Footer />
      </Box>
    </Box>
  );
}
